import { gql } from "@apollo/client";

import {
  AskAiChatMessageFragment,
  ChatSessionMessageReactionFragment,
} from "./get-ask-ai-session-query";

export default gql`
  ${ChatSessionMessageReactionFragment}
  ${AskAiChatMessageFragment}
  mutation getOrCreateChatSession(
    $assessmentId: Int
    $assessmentQuestionId: Int
    $seedWithSuggestedAssessmentAnswer: Boolean
  ) {
    getOrCreateChatbotSession(
      assessmentId: $assessmentId
      assessmentQuestionId: $assessmentQuestionId
      seedWithSuggestedAssessmentAnswer: $seedWithSuggestedAssessmentAnswer
    ) {
      chatSession {
        id
        updated
        reactions {
          edges {
            node {
              ...ChatSessionMessageReactionFragment
            }
          }
        }
        suggestions
        messages {
          edges {
            node {
              ...AskAiChatMessageFragment
            }
          }
        }
      }
    }
  }
`;
